// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductsContent{min-height:calc(100vh - 312px);padding:45px 55px}@media screen and (max-width: 480px){.ProductsContent{padding:20px 25px}}.ProductsContent .CategorySection{margin-bottom:45px}.ProductsContent .CategorySection .CategoryTitle{margin-bottom:35px}.ProductsContent .CategorySection .CategoryTitle img{height:40px;margin-right:10px}.ProductsContent .CategorySection .CategoryTitle span{font-size:18px;font-weight:bold;text-transform:uppercase}", ""]);
// Exports
exports.locals = {
	"primaryColor": "#7d878c",
	"lightPrimary": "#c7cacc",
	"secondaryColor": "#959fa3",
	"lightSecondary": "#eee",
	"tertiaryColor": "#039941",
	"lightTertiary": "#74bd92"
};
module.exports = exports;
